import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/WorldOfAldar/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicBrought/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicCompany/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicDarna/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicExclusive/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicExperience/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicRegistration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WorldOfAldar/LsqSodicWelcome/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ComingSoon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonTransition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisclaimerToggleProvider"] */ "/app/src/hooks/useDisclaimerToggle.tsx");
